import { Reveal } from "./Reveal";

export const SectionLabel = ({ children, light, center }) => (
  <div
    className={`flex items-center gap-3 ${center ? "justify-center" : ""}`}
    style={{ fontFamily: "var(--font-heading)" }}
  >
    <span className="h-px w-8 bg-gradient-to-r from-[#006FD6] to-[#00C4F4]" />
    <span className={`text-xs font-extrabold uppercase tracking-[0.25em] ${light ? "text-[#00C4F4]" : "text-[#006FD6]"}`}>
      {children}
    </span>
    {center && <span className="h-px w-8 bg-gradient-to-r from-[#00C4F4] to-[#006FD6]" />}
  </div>
);

export const SectionHeading = ({ label, title, light, center, className = "", chapter }) => (
  <Reveal className={`${center ? "text-center" : ""} ${className}`}>
    <div className={`flex items-center gap-4 ${center ? "justify-center" : ""}`}>
      {chapter && (
        <span
          className={`text-xs font-bold tracking-widest ${light ? "text-white/30" : "text-[#062541]/30"}`}
          style={{ fontFamily: "var(--font-heading)" }}
        >
          {chapter}
        </span>
      )}
      <SectionLabel light={light} center={center}>{label}</SectionLabel>
    </div>
    <h2
      className={`mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.1] ${light ? "text-white" : "text-[#020A12]"}`}
    >
      {title}
    </h2>
  </Reveal>
);
